import React from 'react'

// redux
import { useSelector } from 'react-redux'

// styles
import Styles from './modernCurrencyInput.module.css'

// icons
import { BiChevronDown } from 'react-icons/bi'

// components
import MarketGraphCard from '../MarketGraphCard/MarketGraphCard'

function ModernCurrencyInput({
  title,
  coinId, // Needed to get the k-line data
  secondaryTitle,
  coinName,
  currencyIcon,
  klineData,
  onChange = () => { },
  currencyImg,
  containerStyle,
  showDropdownArrow = false,
  onDropdownClick,
  showChart = false,
  error,
  hint,
  whiteInput = false,
  register = {},
  disabled = false,
  placeholder = '0.00',
  value,
  type = 'text',
  icon,
  ...rest
}) {
  // ** States
  const theme = useSelector(state => state.theme.value)
  const markets = useSelector(state => state.marketList.value)

  return (
    <>
      <div
        className={`${Styles.modernInputContainer} ${error && Styles.errorContainer}`}
        style={{
          ...containerStyle
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <label className={Styles.inputLabel}>{title}</label>
          {secondaryTitle && <div className={Styles.secondaryTitle}>{secondaryTitle}</div>}
        </div>

        <div className={Styles.inputGroup}>
          <input
            type={type}
            value={value}
            onChange={e => {
              if (Object.keys(register).length !== 0) {
                register && register.onChange(e)
              }
              onChange && onChange(e)
            }}
            className={Styles.inputField}
            placeholder={placeholder}
            disabled={disabled}
            {...register}
            {...rest}
          />

          <div className={Styles.currencySectionContainer}>
            {icon && <div className={Styles.iconContainer}>{icon}</div>}
            <div
              className={`${Styles.currencySection} ${!onDropdownClick && Styles.notHoverable}`}
              onClick={onDropdownClick}
            >
              {currencyImg && (
                <div className={Styles.currencyIcon}>
                  <img src={currencyImg} alt={coinName} />
                </div>
              )}
              {coinName && <span className={Styles.currencyName}>{coinName}</span>}
              {showDropdownArrow && <BiChevronDown className={Styles.dropdownArrow} />}
            </div>
          </div>
        </div>

        {hint && !error?.message && <div className={Styles.hintText}>{hint}</div>}

        {showChart && (
          <MarketGraphCard
            icon={currencyImg}
            coinName={coinName}
            containerStyle={{
              width: '100%',
              marginBottom: '-10px',
              backgroundColor: 'transparent'
            }}
            price={markets.find(el => el.id === `${coinId}usd`)?.last}
            priceChangePercentage={markets.find(el => el.id === `${coinId}usd`)?.price_change_percent}
            marketKLine={klineData}
          />
        )}
      </div>

      {error?.message && <span className={Styles.errorText}>{error.message}</span>}
    </>
  )
}

export default ModernCurrencyInput